import { type CellContext } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

interface CellLinkProps<TData, TValue> extends CellContext<TData, TValue> {
    to: string;
    render?: (value: TValue, row: TData) => React.ReactNode;
}
export function CellLink<TData, TValue>({ getValue, row, render, to }: CellLinkProps<TData, TValue>) {
    const navigate = useNavigate();

    const value = getValue();

    if (value == null) return null;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(to);
    };

    return (
        <div onClick={handleClick} className="text-primary-700 cursor-pointer font-semibold">
            {render ? render(value, row.original) : String(value)}
        </div>
    );
}
